/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Service_TitleInputs */

const da_terms_service_title = /** @type {(inputs: Terms_Service_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tjenesten`)
};

/** @type {(inputs: Terms_Service_TitleInputs) => LocalizedString} */
const en_terms_service_title = da_terms_service_title;

/**

* @param {Terms_Service_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const terms_service_title = /** @type {((inputs?: Terms_Service_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Service_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_service_title(inputs)
	return /** @type {LocalizedString} */ ("Tjenesten")
});